module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 const id = `${styles.input}--${name}`; ;
__p += '\n\n';
 if (type === 'hidden') { ;
__p += '\n  <input\n    type="hidden"\n    name="' +
((__t = ( name )) == null ? '' : __t) +
'"\n    value="' +
((__t = ( typeof value === 'string' ? value : '' )) == null ? '' : __t) +
'"\n    id="' +
((__t = ( id )) == null ? '' : __t) +
'"\n  />\n';
 } else { ;
__p += '\n  <label class="' +
((__t = ( styles.root )) == null ? '' : __t) +
'">\n    <span class="' +
((__t = ( styles.label )) == null ? '' : __t) +
'">' +
((__t = ( label )) == null ? '' : __t);
 if (typeof required === 'boolean' && required) { ;
__p += ' *';
 } ;
__p += '</span>\n    <span>\n      ';
 if (type === 'textarea') { ;
__p += '\n        <textarea\n          class="' +
((__t = ( styles.textarea )) == null ? '' : __t) +
'"\n          id="' +
((__t = ( id )) == null ? '' : __t) +
'"\n          name="' +
((__t = ( name )) == null ? '' : __t) +
'"\n          value="' +
((__t = ( typeof value === 'string' ? value : '' )) == null ? '' : __t) +
'"\n          ';
 if (typeof required === 'boolean' && required) { ;
__p += ' required';
 } ;
__p += '\n          ';
 if (typeof readOnly === 'boolean' && readOnly) { ;
__p += ' readonly';
 } ;
__p += '\n          ';
 for (let attr in attrs) { ;
__p +=
((__t = ( ` ${attr}="${attrs[attr]}"` )) == null ? '' : __t);
 } ;
__p += '\n          ';
 if (typeof description === 'string') { ;
__p += ' aria-describedby="' +
((__t = ( `${id}__desc` )) == null ? '' : __t) +
'"';
 } ;
__p += '\n        ></textarea>\n      ';
 } else { ;
__p += '\n        <input\n          class="' +
((__t = ( styles.input )) == null ? '' : __t) +
'"\n          id="' +
((__t = ( id )) == null ? '' : __t) +
'"\n          type="' +
((__t = ( type || 'text' )) == null ? '' : __t) +
'"\n          name="' +
((__t = ( name )) == null ? '' : __t) +
'"\n          value="' +
((__t = ( typeof value === 'string' ? value : '' )) == null ? '' : __t) +
'"\n          ';
 if (typeof required === 'boolean' && required) { ;
__p += ' required';
 } ;
__p += '\n          ';
 if (typeof readOnly === 'boolean' && readOnly) { ;
__p += ' readonly';
 } ;
__p += '\n          ';
 for (let attr in attrs) { ;
__p +=
((__t = ( ` ${attr}="${attrs[attr]}"` )) == null ? '' : __t);
 } ;
__p += '\n          ';
 if (typeof description === 'string') { ;
__p += ' aria-describedby="' +
((__t = ( `${id}__desc` )) == null ? '' : __t) +
'"';
 } ;
__p += '\n        />\n      ';
 } ;
__p += '\n    </span>\n    ';
 if (typeof description === 'string') { ;
__p += '\n    ' +
((__t = ( info({ content: description, id: `${id}__desc` }) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n    ' +
((__t = ( validation({ name: name }) )) == null ? '' : __t) +
'\n  </label>\n';
 } ;
__p += '\n';

}
return __p
}